import PropTypes from 'prop-types';
import { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Riple } from "react-loading-indicators";
import { AuthContext } from './Provider/AuthProvider';


const PrivateRoute = ({ children }) => {
  const { user, authLoading } = useContext(AuthContext); 
  const location = useLocation();

  if (authLoading) {
    return (
      <div className="min-h-screen flex justify-center items-center">
        <Riple
          color="#3177cc"
          size="medium"
          text="Loading..."
          textColor="#080808"
        />
      </div>
    );
  }

  if (user) {
    return children;
  }

  return <Navigate to="/admin/login" state={{ from: location }} replace />;
};

PrivateRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PrivateRoute;
